var $ = require('jquery');

function WrEditor() {
	var readonly = $("input[name='readonly']");
	if (readonly.val() == 1) {
		$('input[type=text], input[type=password], textarea').prop('readonly', 'readonly');
		$('select, input[type=radio], input[type=checkbox]').prop('disabled', 'disabled');
	}
}

module.exports = WrEditor;